
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <g clip-path="url(#clip0_3112_31679)">
    <path d="M10 0C15.5133 0 20 4.48667 20 10C20 15.5133 15.5144 20 10 20C4.48556 20 0 15.5133 0 10C0 4.48667 4.48556 0 10 0ZM9.34667 14.7089C9.51701 14.8838 9.74724 14.9878 9.99111 15C10.2667 15 10.45 14.9033 10.6344 14.7089L13.8344 11.3311C14.011 11.151 14.1099 10.9089 14.1099 10.6567C14.1099 10.4045 14.011 10.1623 13.8344 9.98222C13.4678 9.59333 12.9156 9.59333 12.5567 9.98222L10.9011 11.72V4.85889C10.9011 4.37444 10.5344 3.88889 9.98222 3.88889C9.43 3.88889 9.06222 4.27778 9.06222 4.85889V11.8167L7.33333 9.97333C6.96667 9.58556 6.41444 9.58556 6.05556 9.97333C5.87898 10.1534 5.78007 10.3956 5.78007 10.6478C5.78007 10.9 5.87898 11.1421 6.05556 11.3222L9.34778 14.7089H9.34667Z"/>
  </g>
  <defs>
    <clipPath id="clip0_3112_31679">
      <rect width="20" height="20"/>
    </clipPath>
  </defs>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'DownloadCircle',
    }) as DefineComponent
    </script>
    